document.addEventListener("DOMContentLoaded", function() {
  var _snow = new Snowfall({
    type: "solid",
    minSize: 3,
    maxSize: 13,
    interval: 300,
    fadeOut: false,
  });

  window.setTimeout(function(){
    let _$boxes = document.querySelectorAll('.box');
    _$boxes.forEach((_$box) => {
      _$box.classList.add('animated');
    });
  }, 1000);
});